import script from "./deliverySearch.vue?vue&type=script&setup=true&lang=js"
export * from "./deliverySearch.vue?vue&type=script&setup=true&lang=js"

import "./deliverySearch.vue?vue&type=style&index=0&id=8c0dd5ae&lang=less"

const __exports__ = script;

export default __exports__